import ButtonPseudo from '../button/button-pseudo';
import Popup from '../popup/popup';
import HintImage from './notification-disabled.png';

import cn from './notification-hint-popup.module.css';

export default function NotifiactionDisabledPopup({
  popupVisible,
  setPopupVisible,
}: {
  popupVisible: boolean;
  setPopupVisible: (data: boolean) => void;
}) {
  return (
    <Popup
      title="It seems that you have disabled notifications from websites"
      onCancelClick={() => setPopupVisible(false)}
      isVisible={popupVisible}
      popupClassName={cn.notificationHintPopup}
    >
      <div className={cn.notifiactionHintPopupContent}>
        <ol>
          <li>
            <div className={cn.orange}>Go to the browser settings</div>
            <div className={cn.grey}>
              Setting – Privacy and Security – Site settings – Notifications
            </div>
          </li>
          <li>
            <div>Enable “Site can ask to send notification”</div>
          </li>
        </ol>
        <img src={HintImage} alt="Hint" className={cn.hintImage} />
        <div className={cn.closeWrapper}>
          <ButtonPseudo
            text="Close"
            onClick={() => setPopupVisible(false)}
            bold
          />
        </div>
      </div>
    </Popup>
  );
}
